import { extendBadge } from './Badge';
import { extendExpressionText } from './ExpressionText';
import { extendGameFrame } from './GameFrame';
import { extendJustTheFactsFrame } from './JustTheFactsFrame';
import { extendNumberWheel } from './NumberWheel';
import { extendPopupMessage } from './PopupMessage';
import { extendPositiveFeedback } from './PositiveFeedback';
import { extendScoreboard } from './Scoreboard';
import { extendValueText } from './ValueText';

export * from './init';

export function extendSymbols() {
  extendBadge();
  extendExpressionText();
  extendGameFrame();
  extendJustTheFactsFrame();
  extendNumberWheel();
  extendPopupMessage();
  extendPositiveFeedback();
  extendScoreboard();
  extendValueText();
}
